// お気に入りクローゼット: 撮影した写真をアプリ側で縮小する（2026-09-24）。
// 送る写真は長辺2048px（RFDBの店撮影と同じ）、一覧用のサムネイルは長辺320px。どちらもJPEG。
// スマホの写真は10MB前後あり、そのまま送ると PostFile の30秒・サーバの8MB上限に掛かるため。

async function loadImage(file) {
  // 向き（EXIF）を反映して読む。createImageBitmap が無い端末は <img> で読む
  if (typeof createImageBitmap === 'function') {
    try { return await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (_) { /* 下で読む */ }
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}

export async function resizeImage(file, maxEdge, quality = 0.85, name = 'photo.jpg') {
  const img = await loadImage(file);
  const w = img.width, h = img.height;
  const scale = Math.min(1, maxEdge / Math.max(w, h));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(w * scale);
  canvas.height = Math.round(h * scale);
  canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
  if (img.close) img.close();
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
  return new File([blob], name, { type: 'image/jpeg' });
}

// 品目区分ごとのアイコン（モックの ITEM_ICONS と同じ線画）
export const ITEM_ICON_PATHS = {
  shirt: ['M8.5 3l3.5 3 3.5-3 4 2.8-2 3.2v11H6.5v-11l-2-3.2z', 'M12 6v13'],
  blouse: ['M8.5 3c0 2 1.6 3.2 3.5 3.2S15.5 5 15.5 3l4 3-2 3v12h-11V9l-2-3z'],
  polo: ['M8.5 3l3.5 3 3.5-3 4 2.8-2 3.2v11H6.5v-11l-2-3.2z', 'M12 6v4', 'M12 7.5h2'],
  pants: ['M7 3h10l-.6 18H13l-1-11-1 11H7.6z', 'M7 3h10'],
  skirt: ['M8 4h8v2l3 15H5l3-15z', 'M8 6h8'],
  knit: ['M9 3h6l5 4.5-2.2 3-1.8-1.3V21H8V9.2L6.2 10.5 4 7.5z'],
  jacket: ['M8.5 3l3.5 2 3.5-2 4 2.8-2 3.2v11h-4v-8h-3v8H6.5v-11l-2-3.2z', 'M12 5v6'],
  dress: ['M9 3l3 2 3-2 2 4.2-1.8 1.3L18 21H6l2.8-12.5L7 7.2z'],
  coat: ['M8.5 3l3.5 2 3.5-2 4 2.8-1.6 2.7V21H6.1V8.5L4.5 5.8z', 'M12 5v16', 'M9.5 12h.5M14.5 12h-.5'],
  other: ['M9.7 9.6a2.4 2.4 0 1 1 3.4 2.2c-.8.4-1.1.9-1.1 1.8', 'M12 16.6h.01'],
};

export const EVENT_LABEL = {
  intake: '写真を登録', clean: 'クリーニング', finish: '仕上げ・加工', repair: '修理', condition: '状態の確認', note: 'メモ',
};
export const PHOTO_LABEL = {
  whole: '服の表', whole_back: '服の裏', label_front: 'ケアラベル', label_back: 'ケアラベル（裏）', brand: 'ブランドタグ',
};
